import { useEffect, useState } from 'react'

import { addressFormat, apiParams } from '../../../utils'
import { childUsers } from '../../../utils/constant'
import { entries, include, isEqual, ternary } from '../../../utils/javascript'
import { getItem } from '../../../utils/localstorage'
import { getEquipmentListApi } from '../../jobs/jobs.api'
import { userChildrenList } from '../../layout/sidebar.description'

const viewUser = ({ userDetails }) => {
  const [equipmentData, setEquipmentData] = useState({
    list: [],
    loader: false,
  })

  useEffect(() => {
    if (!userDetails?.roleId) {
      getEquipmentList({})
    }
  }, [userDetails?.id])

  const getEquipmentList = async ({ pageNo = 1 }) => {
    setEquipmentData(prev => ({ ...prev, loader: true }))
    const params = { buildingId: userDetails?.id, pageSize: 10 }
    const resp = await getEquipmentListApi({
      params: apiParams({ pageNo, params }),
    })
    setEquipmentData(prev => ({ ...resp?.data, loader: false }))
  }

  const handleTableChange = pagination => {
    getEquipmentList({ pageNo: pagination.current })
  }

  const {
    id,
    businessName,
    emailId,
    phoneNumber,
    roleId,
    lastName,
    name,
    parent,
    parentDetails,
  } = {
    ...userDetails,
  }
  const parentData = parent || parentDetails
  const currentUser = userChildrenList.find(val => isEqual(val.userId, roleId))
  const userListView = currentUser?.userView
  const loginUserRoleId = JSON.parse(getItem('userData'))?.roleId

  const getEmailList = () => {
    const emailList = {}
    entries(userDetails).forEach(([key, value]) => {
      if (include(key, 'email') && value) {
        emailList[key] = value
      }
    })
    delete emailList.emailId
    return emailList
  }

  const basicInfoData = [
    { label: 'user_ID', value: id },
    {
      label: 'user_BusinessName',
      value: businessName,
      hidden: include(childUsers, roleId) || !roleId,
    },
    { label: 'user_Name', value: ternary(roleId, lastName, name) },
    {
      label: 'user_Email',
      value: emailId,
      type: 'email',
    },
    { label: 'user_Contact', value: phoneNumber },
    {
      label: 'user_Address',
      value: addressFormat(userDetails),
      isBottomLine: true,
    },
  ]
  const parentInfoData = [
    { label: 'user_ID', value: parentData?.id },
    {
      label: 'user_BusinessName',
      value: parentData?.businessName,
    },
    { label: 'user_Name', value: parentData?.lastName },
    {
      label: 'user_Email',
      value: parentData?.emailId,
      type: 'email',
    },
    { label: 'user_Contact', value: parentData?.phoneNumber },
    {
      label: 'user_Address',
      value: addressFormat(parentData),
    },
  ]
  const otherDetail = [
    { label: 'user_DepartmentName', value: '' },
    { label: 'user_InChargeName', value: '', className: 'border-bottom' },
    // { label: 'user_BusinessNameReporting', value: '' },
    // { label: 'user_AddressReporting', value: '', className: 'border-bottom' },
    // { label: 'user_Enable', value: '' },
    // {
    //   label: 'user_UploadDigitalSignature',
    //   value: '',
    // },
  ]

  return {
    parentData,
    otherDetail,
    userListView,
    basicInfoData,
    parentInfoData,
    loginUserRoleId,
    equipmentData,
    getEmailList,
    getEquipmentList,
    handleTableChange,
  }
}

export default viewUser
